dayjs.extend(window.dayjs_plugin_relativeTime);

const NUM_TO_TEXT = {
    5: "five",
    4: "four",
    3: "three",
    2: "two",
    1: "one",
}

var data;
var summary;
var reviews;
var reviewsLoaded = 0;

var currentScript;
var scriptParent;
var customer_reviews;
var review_section_title;
var review_summary;
var review_average;
var average_rating;
var star_ratings;
var stars_outline;
var stars_filled;
var review_count;
var rating_bars;
var five_star_bar;
var four_star_bar;
var three_star_bar;
var two_star_bar;
var one_star_bar;
var review_summary_break;
var review_gallery;
var reviews_container;
var more_reviews_break;
var more_reviews_button;
var stylesheet;

function loadReviews() {
    var start = reviewsLoaded;
    for (var i = start; i < reviews.length && i < start + 5; i++) {
        if (i > 0) {
            const review_break = createElement({
                class: "review-break",
                parent: reviews_container,
                type: "div",
                text: "&nbsp;",
            });
        }
        const review_item = addReviewItem({
            id: "review-" + i,
            parent: reviews_container,
            info: reviews[i],
        })
        reviewsLoaded++;
    }
    if (reviewsLoaded == reviews.length) {
        more_reviews_break.style.display = "none";
        more_reviews_button.style.display = "none";
    }
}

function createElement(data) {
    const element = document.createElement(data.type);
    if ("class" in data && data.class != "") {
        element.className = data.class;
    }
    if ("id" in data && data.id != "") {
        element.id = data.id;
    }
    if ("text" in data && data.text != "") {
        data.text = data.text.toString().replace(/(?:\r\n|\r|\n)/g, "<br>");
        element.innerHTML = data.text;
    }
    data.parent.appendChild(element);
    return element;
}

function createStars(data) {
    const stars_container = createElement({
        class: data.class1,
        parent: data.parent,
        type: "div",
    });
    for (var i = 0; i < 5; i++) {
        const star_container = createElement({
            class: data.class2,
            parent: stars_container,
            type: "div",
        });
        const star = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        star.setAttributeNS(null, "viewBox", "0 0 16 16");
        star.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        star.setAttribute("role", "img");
        star_container.appendChild(star);
        const star_path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        star_path.setAttribute("class", data.class3);
        // Have to include path in attribute and not css because IOS doesn't support
        star_path.setAttribute("d", "M6.82617 11.442L3.54617 13.166C3.46353 13.2093 3.3704 13.2287 3.27732 13.2219C3.18425 13.2151 3.09494 13.1824 3.0195 13.1274C2.94406 13.0725 2.8855 12.9975 2.85045 12.911C2.8154 12.8245 2.80526 12.7299 2.82117 12.638L3.44817 8.98798C3.46192 8.908 3.456 8.82587 3.43091 8.74869C3.40582 8.67151 3.36232 8.6016 3.30417 8.54499L0.650168 5.95899C0.583317 5.89388 0.53602 5.81136 0.51363 5.72076C0.491239 5.63017 0.494647 5.53512 0.52347 5.44637C0.552292 5.35761 0.605378 5.27869 0.676721 5.21854C0.748065 5.15838 0.834818 5.1194 0.927168 5.10599L4.59317 4.57299C4.67344 4.56146 4.7497 4.53059 4.81537 4.48303C4.88105 4.43547 4.93418 4.37265 4.97017 4.29999L6.61017 0.977985C6.65153 0.894518 6.7154 0.824266 6.79455 0.775151C6.87371 0.726037 6.96501 0.700012 7.05817 0.700012C7.15132 0.700012 7.24263 0.726037 7.32178 0.775151C7.40094 0.824266 7.4648 0.894518 7.50617 0.977985L9.14717 4.29899C9.18307 4.37152 9.23604 4.43426 9.30153 4.48182C9.36702 4.52937 9.44308 4.56031 9.52317 4.57199L13.1892 5.10499C13.2815 5.1184 13.3683 5.15738 13.4396 5.21754C13.511 5.27769 13.564 5.35661 13.5929 5.44537C13.6217 5.53412 13.6251 5.62917 13.6027 5.71976C13.5803 5.81036 13.533 5.89288 13.4662 5.95798L10.8132 8.54398C10.7552 8.60049 10.7118 8.67024 10.6867 8.74723C10.6616 8.82422 10.6556 8.90616 10.6692 8.98598L11.2962 12.637C11.3122 12.7291 11.3021 12.8238 11.267 12.9105C11.232 12.9971 11.1733 13.0722 11.0977 13.1272C11.0221 13.1822 10.9326 13.2149 10.8393 13.2215C10.7461 13.2282 10.6528 13.2086 10.5702 13.165L7.29117 11.441C7.21946 11.4033 7.13967 11.3836 7.05867 11.3836C6.97767 11.3836 6.89788 11.4033 6.82617 11.441V11.442Z");
        star.appendChild(star_path);
    }
    return stars_container;
}

function createRatingBar(data) {
    const rating_bar = createElement({
        class: "rating-bar",
        id: data.id,
        parent: data.parent,
        type: "div",
    });
    const rating_text = createElement({
        class: "rating-text",
        parent: rating_bar,
        type: "div",
        text: data.text,
    });
    const rating_bar_background = createElement({
        class: "rating-bar-background",
        parent: rating_bar,
        type: "div",
    });
    const rating_bar_filled = createElement({
        class: "rating-bar-filled",
        parent: rating_bar_background,
        type: "div",
        text: "&nbsp;",
    });
    rating_bar_filled.style.width = data.width + "%";
    return rating_bar;
}

function createReviewImage(data) {
    const review_image_container = createElement({
        class: "review-image-container",
        parent: data.parent,
        type: "div",
    });
    const hyperlink = createElement({
        parent: review_image_container,
        type: "a",
    })
    hyperlink.href = data.src;
    hyperlink.target = "_blank";
    const review_image = createElement({
        class: "review-image",
        parent: hyperlink,
        type: "img",
    });
    review_image.src = data.src;
    review_image.alt = "Review media";
    review_image.loading = "lazy";
    return review_image_container;
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function addReviewItem(data) {
    const review_item = createElement({
        class: "review-item",
        id: data.id,
        parent: data.parent,
        type: "div",
    });
    const review_profile = createElement({
        class: "review-profile",
        parent: review_item,
        type: "div",
    });
    const review_customer = createElement({
        class: "review-customer",
        parent: review_profile,
        type: "div",
    });
    const customer_image = createElement({
        class: "customer-image",
        parent: review_customer,
        type: "div",
        text: "&nbsp;",
    });
    customer_image.style.backgroundImage = "url(" + data.info.avatarImage + ")";
    const customer_info = createElement({
        class: "customer-info",
        parent: review_customer,
        type: "div",
    });
    const customer_name = createElement({
        class: "customer-name",
        parent: customer_info,
        type: "div",
        text: data.info.customerName,
    });
    const customer_verified = createElement({
        class: "customer-verified",
        parent: customer_info,
        type: "div",
    });
    const review_recommendation = createElement({
        class: "review-recommendation",
        parent: review_profile,
        type: "div",
    });
    var date = new Date(data.info.date);
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - (offset * 60 * 1000));
    const review_date = createElement({
        class: "review-date",
        parent: review_profile,
        type: "div",
        text: dayjs().to(dayjs(date.toISOString().split('T')[0])),
    });
    const review_content = createElement({
        class: "review-content",
        parent: review_item,
        type: "div",
    });
    const review_header = createElement({
        class: "review-header",
        parent: review_content,
        type: "div",
    });
    const star_ratings = createElement({
        class: "star-ratings " + NUM_TO_TEXT[data.info.rating] + "-star-rating",
        parent: review_header,
        type: "div",
    });
    const stars_outline = createStars({
        parent: star_ratings,
        class1: "stars-outline",
        class2: "star-outline",
        class3: "star-path-outline",
    });
    const stars_filled = createStars({
        parent: star_ratings,
        class1: "stars-filled",
        class2: "star-filled",
        class3: "star-path-filled",
    });
    const review_title = createElement({
        class: "review-title",
        parent: review_content,
        type: "div",
        text: data.info.title,
    });
    const review_text_container = createElement({
        class: "review-text-container",
        parent: review_content,
        type: "div",
    });
    var originalReviewText = data.info.content;
    const review_text = createElement({
        class: "review-text",
        parent: review_text_container,
        type: "div",
        text: originalReviewText,
    });
    var charCount = originalReviewText.length;
    var charThreshold = Math.ceil(20 * Math.sqrt(window.screen.width));
    if (charCount > charThreshold) {
        var shortenedReviewText = originalReviewText.substring(0, charThreshold) + "... ";
        review_text.innerHTML = shortenedReviewText.replace(/(?:\r\n|\r|\n)/g, "<br>");
        const review_read_more = createElement({
            class: "review-read-more",
            parent: review_text_container,
            type: "div",
            text: "Read more",
        })
        review_read_more.addEventListener("click", function() {
            if (review_read_more.innerHTML == "Read more") {
                review_text.innerHTML = originalReviewText.replace(/(?:\r\n|\r|\n)/g, "<br>") + " ";
                review_read_more.innerHTML = "Read less";
            } else {
                review_text.innerHTML = shortenedReviewText.replace(/(?:\r\n|\r|\n)/g, "<br>");
                review_read_more.innerHTML = "Read more";
            }
        })
    }
    if ("images" in data.info && data.info.images != []) {
        const review_images_container = createElement({
            class: "review-gallery",
            parent: review_content,
            type: "div",
        })
        for (var i = 0; i < data.info.images.length; i++) {
            createReviewImage({
                parent: review_images_container,
                src: data.info.images[i],
            })
        }
    }
    return review_item;
}

async function getReviews(dataUrl) {
    data = await fetch(dataUrl);
    data = await data.json();
    scriptParent = currentScript.parentElement;

    summary = data.review_summary;
    reviews = data.reviews;

    customer_reviews = document.createElement("div");
    customer_reviews.classList.add("customer-review");

    review_section_title = createElement({
        class: "review-section-title",
        parent: customer_reviews,
        type: "h2",
        text: "Customer Reviews",
    });
    
    review_summary = createElement({
        class: "review-summary",
        parent: customer_reviews,
        type: "div",
    });

    review_average = createElement({
        class: "review-average",
        parent: review_summary,
        type: "div",
    });

    average_rating = createElement({
        class: "average-rating",
        parent: review_average,
        type: "div",
        text: summary.average_star_rating,
    });

    star_ratings = createElement({
        class: "star-ratings",
        parent: review_average,
        type: "div",
    });

    stars_outline = createStars({
        parent: star_ratings,
        class1: "stars-outline",
        class2: "star-outline",
        class3: "star-path-outline",
    });

    stars_filled = createStars({
        parent: star_ratings,
        class1: "stars-filled",
        class2: "star-filled",
        class3: "star-path-filled",
    });
    // Round any rating with a decimal between 0.2 and 0.5 up to 0.5
    var decimal_rating = summary.average_star_rating % 1;
    if (decimal_rating >= 0.2 && decimal_rating < 0.5) {
        summary.average_star_rating = summary.average_star_rating - decimal_rating + 0.5;
    }
    stars_filled.style.width = (summary.average_star_rating / 5 * 100) + "%";

    review_count = createElement({
        class: "review-count",
        parent: review_average,
        type: "div",
        text: numberWithCommas(summary.total_ratings) + " reviews"
    });

    rating_bars = createElement({
        class: "rating-bars",
        parent: review_summary,
        type: "div",
    });

    five_star_bar = createRatingBar({
        id: "five-star-bar",
        parent: rating_bars,
        text: "5",
        width: summary.five_star_percentage,
    });
    four_star_bar = createRatingBar({
        id: "four-star-bar",
        parent: rating_bars,
        text: "4",
        width: summary.four_star_percentage,
    });
    three_star_bar = createRatingBar({
        id: "three-star-bar",
        parent: rating_bars,
        text: "3",
        width: summary.three_star_percentage,
    });
    two_star_bar = createRatingBar({
        id: "two-star-bar",
        parent: rating_bars,
        text: "2",
        width: summary.two_star_percentage,
    });
    one_star_bar = createRatingBar({
        id: "one-star-bar",
        parent: rating_bars,
        text: "1",
        width: summary.one_star_percentage,
    });

    review_summary_break = createElement({
        class: "review-break",
        id: "review-summary-break",
        parent: customer_reviews,
        type: "div",
        text: "&nbsp;",
    });

    review_gallery = createElement({
        class: "review-gallery",
        parent: customer_reviews,
        type: "div",
    });

    for (var i = 0; i < reviews.length; i++) {
        if ("images" in reviews[i] && reviews[i].images != []) {
            for (var j = 0; j < reviews[i].images.length; j++) {
                createReviewImage({
                    parent: review_gallery,
                    src: reviews[i].images[j],
                });
            }
        }
    }

    reviews_container = createElement({
        class: "reviews-container",
        parent: customer_reviews,
        type: "div",
    });

    more_reviews_break = createElement({
        class: "review-break",
        id: "more-reviews-break",
        parent: customer_reviews,
        type: "div",
        text: "&nbsp;",
    });

    more_reviews_button = createElement({
        class: "more-reviews-button",
        parent: customer_reviews,
        type: "button",
        text: "See More Reviews",
    });
    more_reviews_button.addEventListener("click", loadReviews);
    
    loadReviews();

    stylesheet = document.createElement("style");
    stylesheet.type = "text/css";
    stylesheet.innerHTML = `
    .customer-reviews {
        padding: 0em 0.25em;
    }
    .review-section-title {
        line-height: 1;
        margin-bottom: 20px;
        font-size: 28px;
        font-weight: 600;
        text-transform: uppercase;
    }
    .review-summary {
        column-gap: 48px;
        box-sizing: border-box;
        display: flex;
        text-align: center;
    }
    @media screen and (max-width: 480px) {
        .review-title {
            font-size: 26px;
        }
        .review-summary {
            column-gap: 16px;
        }
    }
    .average-rating {
        line-height: 1;
        font-size: 3em;
        font-weight: 400;
    }
    .star-ratings {
        position: relative;
        display: flex;
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .stars-outline {
        display: flex;
        align-items: center;
    }
    .star-outline {
        width: 25px;
    }
    .star-path-outline {
        fill: none;
        stroke: rgb(252, 191, 2);
        stroke-width: 1.5px;
    }
    .stars-filled {
        position: absolute;
        display: flex;
        align-items: center;
        overflow: hidden;
        width: 100%;
    }
    .star-filled {
        flex-shrink: 0;
        width: 25px;
    }
    .star-path-filled {
        fill: rgb(252, 191, 2);
    }
    .review-count {
        font-size: 1em;
        font-weight: 400;
    }
    .rating-bars {
        width: 250px;
    }
    .rating-bar {
        display: flex;
        line-height: 20px;
        align-items: center;
        margin-top: 2px;
        margin-bottom: 2px;
    }
    .rating-text {
        margin-right: 8px;
        font-weight: 400;
    }
    .rating-bar-background {
        width: 100%;
        height: 12px;
        background-color: rgba(0, 0, 0, 0.1);
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .rating-bar-filled {
        width: 100%;
        height: 100%;
        background-color: rgb(252, 191, 2);
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .review-break {
        margin-top: 16px;
        margin-bottom: 16px;
        height: 1px;
        background-color: rgba(0, 0, 0, 0.1);
    }
    #review-summary-break {
        margin-top: 16px;
        margin-bottom: 16px;
    }
    .review-gallery {
        display: flex;
        margin-bottom: 32px;
        column-gap: 8px;
        height: 80px;
        overflow-x: scroll;
        overflow-y: hidden;
        scrollbar-width: none;
    }
    .review-image-container {
        background-image: linear-gradient(0deg, rgb(255, 255, 255), rgb(225, 225, 225));
        flex-shrink: 0;
        width: 80px;
        height: 80px;
        overflow: hidden;
        cursor: pointer;
        border-radius: 8px;
    }
    .review-image {
        object-fit: cover;
        max-width: 100%;
        width: 100%;
        height: 100%;
        vertical-align: top;
    }
    .review-item {
        display: flex;
        padding-bottom: 32px;
    }
    @media screen and (max-width: 480px) {
        .review-item {
            display: block;
        }
    }
    .review-profile {
        min-width: 220px;
        margin-bottom: 16px;
        margin-right: 16px;
    }
    .review-customer {
        display: flex;
        align-items: center;
    }
    .customer-image {
        display: block;
        background-image: linear-gradient(0deg, rgb(255, 255, 255), rgb(136, 136, 136));
        background-position: center;
        background-size: 100%;
        margin-right: 12px;
        min-width: 60px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
    }
    .customer-name {
        max-width: 15ch;
        line-height: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 1.1em;
        font-weight: 400;
    }
    .review-content {
        width: 100%;
    }
    .review-header {
        display: flex;
        margin-bottom: 8px;
    }
    .review-header .star-ratings {
        margin-top: 0px;
    }
    .five-star-rating .stars-filled {
        width: 100%;
    }
    .four-star-rating .stars-filled {
        width: 80%;
    }
    .three-star-rating .stars-filled {
        width: 60%;
    }
    .two-star-rating .stars-filled {
        width: 40%;
    }
    .one-star-rating .stars-filled {
        width: 20%;
    }
    .review-date {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 8px;
        text-align: center;
        font-size: 1em;
        opacity: 0.8;
    }
    .review-title {
        margin-bottom: 8px;
        font-size: 1.4em;
        font-weight: 600;
    }
    .review-text-container {
        font-size: 1.1em;
        font-weight: 400;
    }
    .review-text {
        display: inline;
    }
    .review-read-more {
        display: inline;
        text-decoration: underline;
        font-size: 1em;
        cursor: pointer;
        text-wrap: wrap;
    }
    .review-content .review-gallery {
        margin-top: 16px;
        margin-bottom: auto;
        column-gap: 10px;
        height: 100px;
    }
    .review-content .review-image-container {
        width: 100px;
        height: 100px;
    }
    .reviews-container .review-break {
        margin-top: 0px;
        margin-bottom: 32px;
    }
    #more-reviews-break {
        margin-top: 0px;
        margin-bottom: 16px;
    }
    .more-reviews-button {
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding: 10px 16px;
        border-radius: 8px;
        line-height: 1;
        background-color: rgb(0, 74, 135);
        color: rgb(255, 255, 255);
        border: 0;
        font-size: 1em;
        text-transform: uppercase;
    }
    `;

    scriptParent.appendChild(customer_reviews);
    scriptParent.appendChild(stylesheet);
}

currentScript = document.currentScript;